export default "__VITE_ASSET__CRBximYn__"